import currency from './currency.min.js';

let orders;
let returns;
let staff;

function handleOrderReportFileSelect() {
  orders = undefined;
  returns = undefined;

  if (!window.File || !window.FileReader || !window.FileList || !window.Blob) {
    alert('The File APIs are not fully supported in this browser.');
    return;
  }

  const input = document.getElementById('ordersReport');
  if (!input) {
    alert("Um, couldn't find the ordersReport element.");
  } else if (!input.files) {
    alert("This browser doesn't seem to support the `files` property of file inputs.");
  } else if (!input.files[0]) {
    alert("Please select a file before clicking 'Load'");
  } else {
    const file = input.files[0];
    const fr = new FileReader();
    fr.onload = readOrders;
    fr.readAsBinaryString(file);
  }
}

function readOrders() {
  const data = this.result;
  let workbook;
  try {
    workbook = XLSX.read(data, { type: 'binary' });
  } catch (e) {
    alert(e.message);
    return;
  }

  // TODO receive "PRU" from outside

  let rows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets['Redemptions']);
  if (rows.length === 0) {
    alert('The File doesn\'t seem have a "Redemptions" sheet.');
    return;
  } else if (rows[0]['USERNAME'] === undefined) {
    alert('The "Redemptions" sheet doesn\'t seem to have a "USERNAME" column.');
    return;
  } else if (rows[0]['USERNAME'] === undefined) {
    alert('The "Redemptions" sheet doesn\'t seem to have a "USERNAME" column.');
    return;
  } else if (rows[0]['FIRST NAME'] === undefined) {
    alert('The "Redemptions" sheet doesn\'t seem to have a "FIRST NAME" column.');
    return;
  } else if (rows[0]['LAST NAME'] === undefined) {
    alert('The "Redemptions" sheet doesn\'t seem to have a "LAST NAME" column.');
    return;
  } else if (rows[0]['TAX REMAINING POINTS'] === undefined) {
    alert('The "Redemptions" sheet doesn\'t seem to have a "TAX REMAINING POINTS" column.');
    return;
  } else if (rows[0]['FMV'] === undefined) {
    alert('The "Redemptions" sheet doesn\'t seem to have a "FMV" column.');
    return;
  } else if (rows[0]['OFFICE ID'] === undefined) {
    alert('The "Redemptions" sheet doesn\'t seem to have a "OFFICE ID" column.');
    return;
  }

  orders = [];
  returns = [];
  rows
    .filter((row) => row['OFFICE ID'] !== 'PRU')
    .forEach(function(row) {
      const entry = {
        pin: row['USERNAME'].substring(1),
        firstname: row['FIRST NAME'],
        lastname: row['LAST NAME'],
        taxPointsOwed: parseInt(row['TAX REMAINING POINTS']),
        fairMarketValue: currency(row['FMV']),
      };
      if (isProductNonTaxable(row['PRODUCT NAME'])) {
        returns.push(entry);
      } else {
        orders.push(entry);
      }
    });

  rows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets['Credits']);
  if (rows.length > 0) {
    console.log("HERE")
    console.log(rows.length)
    const requiredFields = ['USERNAME', 'FIRST NAME', 'LAST NAME', 'TAX TOTAL POINTS', 'FMV', 'OFFICE ID'];
    if (requiredFields.some((field) => rows[0][field] === undefined)) {
      alert(`The "Credits" sheet to doesn\'t seem have a ${requiredFields.find((field) => rows[0][field] === undefined)} column.`);
      return;
    }
  } else {
    return;
  }

  rows
    .filter((row) => row['OFFICE ID'] !== 'PRU')
    .forEach(function(row) {
      orders.push({
        pin: row['USERNAME'].substring(1),
        firstname: row['FIRST NAME'],
        lastname: row['LAST NAME'],
        taxPointsOwed: parseInt(row['TAX REMAINING POINTS']),
        fairMarketValue: currency(row['FMV'].replace(/\s/g, '')), // Remove spaces. Values are represented with a space, as in "- 109.99"
      });
    });
}

function handleHRStaffingFileSelect() {
  staff = undefined;

  if (!window.File || !window.FileReader || !window.FileList || !window.Blob) {
    alert('The File APIs are not fully supported in this browser.');
    return;
  }

  const input = document.getElementById('hrStaffing');
  if (!input) {
    alert("Um, couldn't find the hrStaffing element.");
  } else if (!input.files) {
    alert("This browser doesn't seem to support the `files` property of file inputs.");
  } else if (!input.files[0]) {
    alert("Please select a file before clicking 'Load'");
  } else {
    const file = input.files[0];
    const fr = new FileReader();
    fr.onload = readStaff;
    fr.readAsBinaryString(file);
  }
}

function readStaff() {
  const data = this.result;
  let workbook;
  try {
    workbook = XLSX.read(data, { type: 'binary' });
  } catch (e) {
    alert(e.message);
    return;
  }

  // Identify the correct sheet: the one that does NOT have the DATA_TYPE column
  let activeSheetName = null;
  for (const sheetName of workbook.SheetNames) {
    const rows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
    if (rows.length === 0) continue;

    // If DATA_TYPE is not found, this is likely the Active Employees sheet
    if (!('DATA_TYPE' in rows[0])) {
      activeSheetName = sheetName;
      break;
    }
  }

  if (!activeSheetName) {
    alert('No sheet with active employees found');
    return;
  }

  const rows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[activeSheetName]);

  // Validate required columns
  const requiredColumns = [
    'EMPLOYEE_NUMBER',
    'EMPLOYEE_FIRST_NAME',
    'EMPLOYEE_LAST_NAME',
    'EMPLOYEE_EMAIL_ADDRESS',
  ];

  for (const col of requiredColumns) {
    if (rows[0][col] === undefined) {
      alert(`The sheet "${activeSheetName}" doesn't seem to have a "${col}" column.`);
      return;
    }
  }

  // Populate staff map
  staff = new Map();
  rows.forEach(function (row) {
    staff.set(row['EMPLOYEE_NUMBER'], {
      firstname: row['EMPLOYEE_FIRST_NAME'],
      lastname: row['EMPLOYEE_LAST_NAME'],
      email: row['EMPLOYEE_EMAIL_ADDRESS'],
    });
  });
}

function generateTaxFiles() {
  if (returns === undefined || orders === undefined) {
    alert('Please provide an "Orders report" spreadsheet (from "Reports -> Generate Excel Report)');
    return;
  } else if (staff === undefined) {
    alert('Please provide a "HR Staffing" spreadsheet');
    return;
  }

  const nonTaxables = generateNonTaxableMap(returns, staff);
  const grossedUp = generateGrossUpMap(orders, staff);
  const taxables = generateTaxableMap(orders, staff);
  const mailMerge = generateMailMergeMap(taxables, staff);

  downloadMaster(nonTaxables, grossedUp, taxables, mailMerge);
}

function downloadMaster(nonTaxables, grossedUp, taxables, mailMerge) {
  const wb = XLSX.utils.book_new();

  const ws_data_taxable = [];
  ws_data_taxable.push(['Sum of FMV']);
  ws_data_taxable.push(['PIN', 'Last Name', 'First name', 'Total']);
  taxables.forEach(function(value, key) {
    ws_data_taxable.push([key, value.lastname, value.firstname, value.fairMarketValueTotal.value]);
  });
  const ws_taxable = XLSX.utils.aoa_to_sheet(ws_data_taxable);
  XLSX.utils.book_append_sheet(wb, ws_taxable, 'Taxable');

  const ws_data_mail = [];
  ws_data_mail.push(['Sum of FMV']);
  ws_data_mail.push(['PIN', 'Last Name', 'First name', 'Email', 'Total']);
  mailMerge.forEach(function(value, key) {
    ws_data_mail.push([key, value.lastname, value.firstname, value.email, value.fairMarketValueTotal.value]);
  });
  const ws_mail = XLSX.utils.aoa_to_sheet(ws_data_mail);
  XLSX.utils.book_append_sheet(wb, ws_mail, 'Mailmerge');

  const ws_data_gross = [];
  ws_data_gross.push(['Sum of FMV']);
  ws_data_gross.push(['PIN', 'Last Name', 'First name', 'Total']);
  grossedUp.forEach(function(value, key) {
    ws_data_gross.push([key, value.lastname, value.firstname, value.fairMarketValueTotal.value]);
  });
  const ws_gross = XLSX.utils.aoa_to_sheet(ws_data_gross);
  XLSX.utils.book_append_sheet(wb, ws_gross, 'Gross Up');

  const ws_data_nontaxable = [];
  ws_data_nontaxable.push(['Sum of FMV']);
  ws_data_nontaxable.push(['PIN', 'Last Name', 'First name', 'Total']);
  nonTaxables.forEach(function(value, key) {
    ws_data_nontaxable.push([key, value.lastname, value.firstname, value.fairMarketValueTotal.value]);
  });
  const ws_nonTaxable = XLSX.utils.aoa_to_sheet(ws_data_nontaxable);
  XLSX.utils.book_append_sheet(wb, ws_nonTaxable, 'Other');

  XLSX.writeFile(wb, 'Master_taxation.xlsx');
}

function generateGrossUpMap(orders, staff) {
  const grossedUp = new Map();
  orders
    .filter((order) => order.taxPointsOwed === 0)
    .forEach(function(order) {
      const entry = {
        pin: order.pin,
        lastname: order.lastname,
        firstname: order.firstname,
        fairMarketValueTotal: order.fairMarketValue,
      };

      const staffValues = staff.get(entry.pin);
      if (staffValues !== undefined) {
        entry.lastname = staffValues.lastname || entry.lastname;
        entry.firstname = staffValues.firstname || entry.firstname;
      }

      const alreadyGrossedUp = grossedUp.get(entry.pin);
      if (alreadyGrossedUp !== undefined) {
        entry.fairMarketValueTotal = entry.fairMarketValueTotal.add(alreadyGrossedUp.fairMarketValueTotal);
      }

      grossedUp.set(entry.pin, entry);
    });
  return grossedUp;
}

function generateTaxableMap(orders, staff) {
  const taxables = new Map();
  orders
    .filter((order) => order.taxPointsOwed !== 0)
    .forEach(function(order) {
      const entry = {
        pin: order.pin,
        lastname: order.lastname,
        firstname: order.firstname,
        fairMarketValueTotal: order.fairMarketValue,
      };

      const staffValues = staff.get(entry.pin);
      if (staffValues !== undefined) {
        entry.lastname = staffValues.lastname || entry.lastname;
        entry.firstname = staffValues.firstname || entry.firstname;
      }

      const alreadyTaxable = taxables.get(entry.pin);
      if (alreadyTaxable !== undefined) {
        entry.fairMarketValueTotal = entry.fairMarketValueTotal.add(alreadyTaxable.fairMarketValueTotal);
      }

      if (entry.fairMarketValueTotal === 0) {
        taxables.delete(entry.pin);
      } else {
        taxables.set(entry.pin, entry);
      }
    });
  return taxables;
}

function generateNonTaxableMap(orders, staff) {
  const nonTaxables = new Map();
  orders.forEach(function(order) {
    const entry = {
      pin: order.pin,
      lastname: order.lastname,
      firstname: order.firstname,
      fairMarketValueTotal: order.fairMarketValue,
    };

    const staffValues = staff.get(entry.pin);
    if (staffValues !== undefined) {
      entry.lastname = staffValues.lastname || entry.lastname;
      entry.firstname = staffValues.firstname || entry.firstname;
    }

    const alreadyNonTaxable = nonTaxables.get(entry.pin);
    if (alreadyNonTaxable !== undefined) {
      entry.fairMarketValueTotal = entry.fairMarketValueTotal.add(alreadyNonTaxable.fairMarketValueTotal);
    }

    if (entry.fairMarketValueTotal === 0) {
      nonTaxables.delete(entry.pin);
    } else {
      nonTaxables.set(entry.pin, entry);
    }
  });
  return nonTaxables;
}

function generateMailMergeMap(taxables, staff) {
  const mailMerge = new Map();
  taxables.forEach(function(taxable) {
    const entry = {
      pin: taxable.pin,
      lastname: taxable.lastname,
      firstname: taxable.firstname,
      fairMarketValueTotal: taxable.fairMarketValueTotal,
    };

    const staffValues = staff.get(entry.pin);
    if (staffValues !== undefined) {
      entry.email = staffValues.email || undefined;
    }

    if (entry.email !== undefined) {
      mailMerge.set(entry.pin, entry);
    }
  });
  return mailMerge;
}

function isProductNonTaxable(productName) {
  if (productName === undefined || productName === null) {
    return false;
  }
  const lowercase = productName.toLowerCase();
  return lowercase.startsWith('return') || lowercase.startsWith('restock') || lowercase.startsWith('reship');
}

// extend FileReader
// https://stackoverflow.com/a/32665193/2001566
if (!FileReader.prototype.readAsBinaryString) {
  FileReader.prototype.readAsBinaryString = function(fileData) {
    let binary = '';
    const pt = this;
    const reader = new FileReader();
    reader.onload = function(e) {
      const bytes = new Uint8Array(reader.result);
      const length = bytes.byteLength;
      for (let i = 0; i < length; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      //pt.result  - readonly so assign binary
      pt.content = binary;
      $(pt).trigger('onload');
    };
    reader.readAsArrayBuffer(fileData);
  };
}

export { handleOrderReportFileSelect, handleHRStaffingFileSelect, generateTaxFiles };
